<template>
    <div>
        <div
            :class="opacity"
            class="fixed top-0 left-0 w-full h-full bg-stone-900 z-40"
        ></div>
        <div
            class="fixed top-0 left-0 w-full h-full flex items-center justify-center z-40"
        >
            <div class="flex flex-col items-center justify-center">
                <slot />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps({
        opacity: {
            type: String,
            default: 'opacity-60',
        },
    })
</script>
